var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L0 1.99965L2.33443 0L7 4.00071L11.6656 0L14 1.99965L7 8Z",
    fill: "#564AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentDownArrow);
export default __webpack_public_path__ + "static/media/currentDownArrow.264ed113849d18ee2d1f6979509b4d6b.svg";
export { ForwardRef as ReactComponent };